<template>
  <div>
    <h2>Regioes estado</h2>

    <div v-if="filtered.length">
      <b-row>
        <b-table striped hover show-empty :items="filtered" :fields="fields">
          <template slot="thead-top" slot-scope="{ fields }">
            <b-tr>
              <b-th v-for="field in fields" :key="field.key">
                <b-form-input
                  v-model="filters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </b-th>
            </b-tr>
          </template>
          <template v-slot:cell(prazo)="row">
            <b-form-input v-model="row.item.prazo" v-on:change="onDataChange(row.item)" />
          </template>
          <template v-slot:cell(diasPosColeta)="row">
            <b-form-input v-model="row.item.diasPosColeta" v-on:change="onDataChange(row.item)" />
          </template>
        </b-table>
      </b-row>
      <b-row>
        <b-col sm="5" md="5" lg="5" class="mt-1">
          <b-pagination
            v-model="tableCurrentPage"
            :total-rows="tableRowCount"
            :per-page="tablePerPage"
            first-number
            last-number
            aria-controls="table-tabela-proceda"
          ></b-pagination>
        </b-col>
        <b-col sm="4" md="4" lg="4" class="mt-2">
          <label
            for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{tableRowCount}}</label>
        </b-col>
        <b-col sm="3" md="3" lg="3">
          <b-form-group
            label-cols-md="6"
            label="Por página"
            label-align-md="right"
            label-for="perPageSelect"
          >
            <b-form-select
              class="mt-1"
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            ></b-form-select>
          </b-form-group>
          <!-- <b-form-select
            v-model="tablePerPage"
            id="perPageSelect"
            size="sm"
            :options="tablePageOptions"
          ></b-form-select>-->
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-table striped show-empty :items="filtered" :fields="fields">
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <b-form-input
                v-model="filters[field.key]"
                :placeholder="'Buscar por ' + field.label"
              />
            </b-th>
          </b-tr>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "PrazoEntregaRegioesEstado",
  props: {
    transportadorId: null,
  },
  computed: {
    filtered() {
      const filtered = this.items.filter((item) => {
        return Object.keys(this.filters).every((key) => {
          let sections = key.split(".");
          let object = item;
          for (let i = 0; i < sections.length; i++) {
            object = object[sections[i]];
          }
          return String(object)
            .toUpperCase()
            .includes(this.filters[key].toUpperCase());
        });
      });
      //return filtered;
      const returnList = [];
      for (
        var i = (this.tableCurrentPage - 1) * this.tablePerPage;
        i < this.tableCurrentPage * this.tablePerPage && i < filtered.length;
        i++
      ) {
        returnList.push(filtered[i]);
      }
      return returnList;
    },
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  data: function () {
    return {
      fields: [
        {
          label: "Região estado",
          key: "regiaoEstado.nome",
          sortable: true,
        },
        {
          label: "Prazo",
          key: "prazo",
          sortable: true,
        },
        {
          label: "Dias pos coleta",
          key: "diasPosColeta",
          sortable: true,
        },
      ],
      filters: {
        "regiaoEstado.nome": "",
        prazo: "",
        diasPosColeta: "",
      },
      items: [],
      tableRowCount: 0,
      tablePerPage: 5,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  created: function () {
    this.loadData();
  },
  watch: {
    transportadorId() {
      this.loadData();
    },
  },
  methods: {
    async loadData() {
      if (this.transportadorId) {
        this.$api
          .get("/rotaPrazoEntrega/regioesEstado/" +this.transportadorId.toString())
          .then((response) => {
            this.items = response.data;
            this.tableRowCount = this.items.length;
          })
          .catch((error) => {
            console.log(error);
            this.items = [];
            this.tableRowCount = this.items.length;
          });
      } else {
        console.log("load regioesEstado without transportadorId");
        this.$api
          .get("/rotaPrazoEntrega/regioesEstado/1")
          .then((response) => {
            this.items = response.data;
            this.tableRowCount = this.items.length;
          })
          .catch((error) => {
            console.log(error);
            this.items = [];
            this.tableRowCount = this.items.length;
          });
      }
    },
    onDataChange: function (item) {
      item.prazo = parseInt(item.prazo);
      item.diasPosColeta = parseInt(item.diasPosColeta);

      this.$api
        .post(
          "/rotaPrazoEntrega/save/" +
            item.transportadorId.toString() +
            "/" +
            item.id.toString(),
          item
        )
        .then((response) => {
          item.id = response.data.id;
          console.log(JSON.stringify(item));
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response.data.errors);

          if (error.response.status == 400) {
            alert(error.response.data.errors);
          }
        });
    },
  },
};
</script>

